<script setup lang="ts">
</script>

<template>
  <div class="ui-container">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.ui-container {
  width: 100%;
  max-width: $container-max-width;
  margin-inline: auto;
  padding-inline: $container-padding;
}
</style>
